import { Check, Pencil } from "lucide-react";
import React from "react";

export const inputCls = "w-full px-3 py-2 bg-black/40 border border-white/10 focus:border-nex-gold/60 outline-none text-nex-silver text-sm rounded-sm";
export const labelCls = "block font-mono text-[9px] tracking-[0.22em] uppercase text-nex-muted mb-1.5";

export const GoldButton = ({ children, className = "", ...p }) => (
  <button type="button" {...p}
    className={`inline-flex items-center gap-2 px-3 py-1.5 bg-nex-gold/15 border border-nex-gold text-nex-gold font-mono text-[10px] tracking-[0.2em] uppercase rounded-sm hover:bg-nex-gold/25 transition-colors disabled:opacity-50 ${className}`}>
    {children}
  </button>
);

export const GhostButton = ({ children, className = "", ...p }) => (
  <button type="button" {...p}
    className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 border border-white/10 text-nex-muted hover:text-nex-silver hover:border-white/30 font-mono text-[10px] tracking-[0.18em] uppercase rounded-sm transition-colors disabled:opacity-40 ${className}`}>
    {children}
  </button>
);

export const Pill = ({ children, tone = "gold", ...p }) => {
  const tones = {
    gold: "border-nex-gold/40 bg-nex-gold/10 text-nex-gold",
    green: "border-emerald-400/40 bg-emerald-400/10 text-emerald-300",
    red: "border-red-400/40 bg-red-400/10 text-red-300",
    dim: "border-white/15 bg-white/5 text-nex-muted",
    yellow: "border-yellow-400/40 bg-yellow-400/10 text-yellow-300",
    blue: "border-sky-400/40 bg-sky-400/10 text-sky-300",
  };
  return <span {...p} className={`inline-flex items-center px-2 py-0.5 rounded-full border font-mono text-[9px] tracking-[0.18em] uppercase ${tones[tone]}`}>{children}</span>;
};

export const Empty = ({ children, testId }) => (
  <div data-testid={testId} className="py-10 text-center text-nex-muted text-sm">{children}</div>
);

export const ErrorLine = ({ children, testId }) => children ? (
  <p data-testid={testId} className="text-xs text-red-300">{children}</p>
) : null;

/** Top-right "Edit" toggle, same spot and style as "Edit profile". */
export const EditToggle = ({ editing, setEditing, label = "Edit", testId }) => (
  <div className="flex justify-end">
    <GhostButton data-testid={`${testId}-${editing ? "done" : "edit"}`} onClick={() => setEditing(!editing)}>
      {editing ? <><Check className="h-3 w-3" /> Done editing</> : <><Pencil className="h-3 w-3" /> {label}</>}
    </GhostButton>
  </div>
);
